import clsx from 'clsx'
import { Button } from 'avo-ui'
import icChevronDown from '../../../assets/images/ic-chevron-down.svg'
import icChevronUp from '../../../assets/images/ic-chevron-up.svg'
import icArrowUpWhite from '../../../assets/images/ic-arrow-up-white.svg'
import icArrowDownWhite from '../../../assets/images/ic-arrow-down-white.svg'
import icTrash from '../../../assets/images/ic-trash.svg'
import { useState } from 'react'
import ModalDelete from '../modal-delete'

const TabToggleList = ({
    className,
    index,
    title = 'item',
    content,
    items,
    setItems,
    deleteIds,
    setDeleteIds,
    isDisableDelete,
    isSorting,
}) => {
    const [show, setShow] = useState(true)
    const [isShowDelete, setIsShowDelete] = useState(false)
    const itemsCopy = [...items]
    const getItem = itemsCopy[index]

    const setShowContent = () => {
        setShow(!show)
    }

    const checkNewPosition = (type, index) => {
        if (type === 'up') {
            return index - 1 < 0 ? 0 : index - 1
        } else {
            return index < items?.length - 1 ? index + 1 : index
        }
    }

    const onDeleteItem = () => {
        const updateItem = itemsCopy?.filter((_, i) => i !== index)
        setItems(updateItem)
        setIsShowDelete(false)
        if (setDeleteIds) {
            const newDeleteIds = getItem?.id ? [...deleteIds, getItem?.id] : [...deleteIds]
            setDeleteIds(newDeleteIds)
        }
    }

    const onChangePosition = (direction) => {
        itemsCopy[index] = itemsCopy[checkNewPosition(direction, index)]
        itemsCopy[checkNewPosition(direction, index)] = getItem
        setItems(itemsCopy)
    }

    return (
        <div className={clsx('flex flex-col divide-y divide-blue-100 border border-blue-100 rounded-lg', className)}>
            <div className={'flex items-center justify-between p-4 bg-neutral-5 rounded-lg'}>
                <p className={'text-sm text-blue-90 font-bold capitalize'}>{title}</p>
                <div className={'flex items-center space-x-4'}>
                    <div
                        className={`flex items-center space-x-4 ${items.length > 1 && isSorting ? 'block' : 'hidden'}`}
                    >
                        <Button
                            icon={icArrowDownWhite}
                            disabled={index === items.length - 1}
                            onClick={() => onChangePosition('down')}
                        />
                        <Button icon={icArrowUpWhite} disabled={index === 0} onClick={() => onChangePosition('up')} />
                    </div>
                    <Button
                        type={'outline'}
                        icon={show ? icChevronUp : icChevronDown}
                        className={'!rounded-full'}
                        onClick={setShowContent}
                    />
                </div>
            </div>
            <div className={show ? 'block p-4' : 'hidden'}>{content}</div>
            <div className={`flex justify-end p-3 ${show ? 'block' : 'hidden'}`}>
                <Button
                    type={'outline'}
                    icon={icTrash}
                    title={'Delete'}
                    onClick={() => setIsShowDelete(true)}
                    disabled={isDisableDelete}
                />
            </div>
            <ModalDelete
                show={isShowDelete}
                onHide={() => setIsShowDelete(false)}
                description={'Are You Sure Delete This?'}
                onDelete={onDeleteItem}
            />
        </div>
    )
}

export default TabToggleList
